import { configureStore } from "@reduxjs/toolkit";
import DashOptionsSliceReducer from "../Slice/DashOptionsSlice"
import BillingDataSliceReducer from "../Slice/BillingSlice"
export const store = configureStore({
    reducer: {
        DashOptionsSlice: DashOptionsSliceReducer,
        BillingDataSlice: BillingDataSliceReducer
    }
})